// import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import React, { FC } from "react";
import { Tooltip } from "antd";
import { HiOutlineThumbUp, HiThumbUp } from "react-icons/hi";

interface LikeProps {
  design?: any;
  user?: any;
}

const LikeDesign: FC<LikeProps> = ({ design, user }) => {
  // const [hasLiked, setHasLiked] = useState(false);

  // useEffect(() => {
  //   const ratedUserById = design?.owner?.likedBy;
  //   const hasRated = ratedUserById?.find((single: any) => single.ratedByUserId);
  //   setHasLiked(hasRated ? true : false);
  // }, [design?.owner?.likedBy]);
  const hasLiked =
    user &&
    design.likedBy &&
    design.likedBy.find(
      (l) => l.ratedByUserId.toString() === user._id.toString()
    );

  return (
    <Tooltip placement="bottom" title={"Likes"}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontWeight: 600,
          color: "#3d3d4e",
        }}
      >
        {hasLiked ? (
          <>
            <HiThumbUp
              style={{ fontSize: "1rem", marginRight: 2, color: "#1890ff" }}
            />
            {design?.totalLikes || 0}
            {/* <span style={{ marginLeft: 5 }}>Likes</span> */}
          </>
        ) : (
          <>
            <HiOutlineThumbUp style={{ fontSize: "1rem", marginRight: 2 }} />
            {design?.totalLikes || 0}
            {/* <span style={{ marginLeft: 5 }}>Likes</span> */}
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default LikeDesign;
